import React from 'react';
import __ from 'lodash';
 
class DropdownJadwalProfilCbt extends React.Component{
    render(){
        return (
            this.props.jadwalProfil.map((val) =>
                <option key={val.idJadwalProfilCbt} value={val.idJadwalProfilCbt}>{val.namaJadwalProfilCbt}</option>
            )            
        )
    }
}

export default DropdownJadwalProfilCbt;